import PepLoginModal from 'features/PMSReports/PepLoginModal'
import usePepLoginModal from 'hooks/usePepLoginModal'
import React from 'react'

/**
 * Global PEP login overlay for Electron (main process opens via IPC).
 */
export function PepLoginModalHost() {
  const {
    modalState,
    submitError,
    isSubmitting,
    submitCredentials,
    cancelModal,
    isOpen
  } = usePepLoginModal()

  return (
    <PepLoginModal
      isOpen={isOpen}
      submitError={submitError}
      isSubmitting={isSubmitting}
      onSubmit={submitCredentials}
      onCancel={cancelModal}
    />
  )
}

export default PepLoginModalHost
